// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const FileOut = zod.object({
  "content_type": zod.string(),
  "filename": zod.string(),
  "id": zod.uuid(),
  "reused": zod.boolean(),
  "size_bytes": zod.int(),
  "text_status": zod.string()
});

export type FileOut = zod.input<typeof FileOut>;
export type FileOutOutput = zod.output<typeof FileOut>;
